import React from 'react';
import { styled } from 'linaria/react';
import { RoomParams } from './components/RoomParams';
import { Hints } from './components/Hints';
import { Result } from './components/Result';
import { LaminateCalculateBannerResult } from './components/LaminateCalculateBanner';

export const CalculationForm = () => (
  <CalculationFormContainer>
    <RoomParams />
    <Hints />
    <Result />
    <LaminateCalculateBannerResult />
  </CalculationFormContainer>
);

const CalculationFormContainer = styled.div`
  margin-top: var(--space-200);
`;
